import styled from "styled-components";
const PostSectionStyle = styled.div`
  width: 50%;
  @media only screen and (max-width: 800px) {
    width:80%;
  }
`;
export default PostSectionStyle;
